<!-- <div class="confirm-modal-align">
    <h1  mat-dialog-title>{{title}}</h1>
    <mat-dialog-content> {{errorMessage}} </mat-dialog-content>
<mat-dialog-actions class="confirm-modal-button">
    <button class="confirm-modal-button-color" mat-raised-button (click)="closeMe()">OK</button>
</mat-dialog-actions>
</div> -->

<mat-expansion-panel [expanded]="true" hideToggle style="min-width: 500px;">
  <mat-expansion-panel-header class='header' [ngClass]="warning ? 'warningHeader' : ''" style="pointer-events: none;">
    <mat-panel-description>
      {{title}}
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div fxLayoutAlign="center">
    <p class="mt-3 mb-3 breakline">{{errorMessage}}</p>
  </div>
  <div fxLayoutAlign="center">
    <button class="confirm-modal-button-color" mat-raised-button (click)="closeMe()">OK</button>
  </div>
</mat-expansion-panel>
